
import React, { Component } from 'react';

import styled from 'styled-components';
import AppLogo from './AppLogo';
import Paper from '@material-ui/core/Paper';
import {UserToolbar} from "./components/User/Toolbar";


const LoginContainer = styled.div`
  display: grid;
	height: 100dvh;
	background: #FBFBFB;
`;

const Container = styled.div`
  width: 340px;
  align-self: center;
  justify-self: center;
`;

const StyledPaper = styled(Paper)`
  padding: 40px;
  
  h2, h4 {
    font-weight: normal;
    margin: 0;
    padding: 0;
  }
`;


export default class Error403 extends Component {

  static defaultProps = {
    label: 'Доступ закрыт'
  }

  render() {
    const { label } = this.props;
    return(
      <LoginContainer>
        <Container>
          <div className={'text-center mb-40'}>
            <AppLogo />
          </div>
          <StyledPaper>
            <div className={'text-center'}>
              <h2 className={'mb-20'}>Ошибка 403</h2>
              <h4>{label}</h4>

              <div className={'mt-20'}>
                <UserToolbar />
              </div>
            </div>
          </StyledPaper>
        </Container>
      </LoginContainer>
    )
  }
}
